export function filterUndefinedValues(obj: object): object {
  return Object.fromEntries(
    Object.entries(obj)
      .filter(([,v]) => v !== undefined)
  )
}